var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48193 12C2.42193 6.88 6.90893 3 12.3009 3C17.6929 3 22.1789 6.88 23.1199 12C22.1799 17.12 17.6929 21 12.3009 21C6.90893 21 2.42293 17.12 1.48193 12ZM12.3009 17C13.627 17 14.8988 16.4732 15.8365 15.5355C16.7741 14.5979 17.3009 13.3261 17.3009 12C17.3009 10.6739 16.7741 9.40215 15.8365 8.46447C14.8988 7.52678 13.627 7 12.3009 7C10.9749 7 9.70308 7.52678 8.7654 8.46447C7.82772 9.40215 7.30093 10.6739 7.30093 12C7.30093 13.3261 7.82772 14.5979 8.7654 15.5355C9.70308 16.4732 10.9749 17 12.3009 17ZM12.3009 15C11.5053 15 10.7422 14.6839 10.1796 14.1213C9.617 13.5587 9.30093 12.7956 9.30093 12C9.30093 11.2044 9.617 10.4413 10.1796 9.87868C10.7422 9.31607 11.5053 9 12.3009 9C13.0966 9 13.8596 9.31607 14.4223 9.87868C14.9849 10.4413 15.3009 11.2044 15.3009 12C15.3009 12.7956 14.9849 13.5587 14.4223 14.1213C13.8596 14.6839 13.0966 15 12.3009 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEye);
export default __webpack_public_path__ + "static/media/showEye.c4459f0fa68c9f2e01f518824f0067e8.svg";
export { ForwardRef as ReactComponent };